import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { startSubscriptionCheckout } from "../lib/publicCheckout";

function localDevCheckoutBypass(token) {
  return (
    process.env.REACT_APP_LOCAL_DEV_AUTH === "true" &&
    token === "local-dev" &&
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  );
}

/**
 * /checkout: sesión requerida para enviar user_id/email a Lemon; invitados → registro con retorno.
 */
export default function CheckoutRedirect() {
  const { user, loading, token } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (localDevCheckoutBypass(token)) {
      startSubscriptionCheckout();
      return;
    }
    if (user?.id) {
      startSubscriptionCheckout({
        userId: user.id,
        email: user.email,
        name: user.nombre,
      });
    }
  }, [user, loading, token]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-slate-50 to-sky-50 text-slate-600 text-sm p-4 text-center">
        Cargando sesión…
      </div>
    );
  }

  if (!user?.id && !localDevCheckoutBypass(token)) {
    return <Navigate to="/register?next=%2Fcheckout" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-slate-50 to-sky-50 text-slate-600 text-sm p-4 text-center">
      Redirigiendo al proceso de pago seguro…
    </div>
  );
}
